export default "__VITE_ASSET__42b5af2e__"